module.exports = __webpack_public_path__ + "img/img_target_left_af.e4d8ff8f.svg";